const AbyedhADIL = {
    /*sante*/
    docteur: {
        tag: 'docteur',
        themeColor: '#087159',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall : [
            [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
                { id: 4, name: 'امراض الرئة', value: 'dentiste', imgSrc: 'PNEUMOLOGIE' },
            ],
            [
                { id: 5, name: 'العيون', value: 'dentiste', imgSrc: 'OPHTALMOLOGIE' },
                { id: 6, name: 'أذن أنف حنجرة', value: 'dentiste', imgSrc: 'ORL' },
                { id: 7, name: 'الأعصاب', value: 'dentiste', imgSrc: 'NEUROLOGIE' },
                { id: 8, name: 'الكلي', value: 'dentiste', imgSrc: 'UROLOGIE' },
            ],
            [
                { id: 9, name: 'نساء و توليد', value: 'dentiste', imgSrc: 'GYNECOLOGIE_OBSTETRIQUE' },
                { id: 10, name: 'الجهاز الهضمي', value: 'dentiste', imgSrc: 'GASTROLOGIE' },
                { id: 11, name: 'الغدد', value: 'dentiste', imgSrc: 'ENDOCRINOLOGIE' },
                { id: 12, name: 'البشرة', value: 'dentiste', imgSrc: 'DERMATOLOGIE' },
            ],
            [
                { id: 13, name: 'القلب', value: 'dentiste', imgSrc: 'CARDIOLOGIE' },
                { id: 14, name: 'النفس', value: 'dentiste', imgSrc: 'PSYCHIATRIE' },
                { id: 15, name: 'التغذية', value: 'dentiste', imgSrc: 'NUTRITION' },
            ]
        ],
        subCatagLarge : [
            [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
                { id: 4, name: 'امراض الرئة', value: 'dentiste', imgSrc: 'PNEUMOLOGIE' },
                { id: 5, name: 'العيون', value: 'dentiste', imgSrc: 'OPHTALMOLOGIE' },
                { id: 6, name: 'أذن أنف حنجرة', value: 'dentiste', imgSrc: 'ORL' },
                { id: 7, name: 'الأعصاب', value: 'dentiste', imgSrc: 'NEUROLOGIE' },
                { id: 8, name: 'الكلي', value: 'dentiste', imgSrc: 'UROLOGIE' },
            ],
            [
                { id: 9, name: 'نساء و توليد', value: 'dentiste', imgSrc: 'GYNECOLOGIE_OBSTETRIQUE' },
                { id: 10, name: 'الجهاز الهضمي', value: 'dentiste', imgSrc: 'GASTROLOGIE' },
                { id: 11, name: 'الغدد', value: 'dentiste', imgSrc: 'ENDOCRINOLOGIE' },
                { id: 12, name: 'البشرة', value: 'dentiste', imgSrc: 'DERMATOLOGIE' },
                { id: 13, name: 'القلب', value: 'dentiste', imgSrc: 'CARDIOLOGIE' },
                { id: 14, name: 'النفس', value: 'dentiste', imgSrc: 'PSYCHIATRIE' },
                { id: 15, name: 'التغذية', value: 'dentiste', imgSrc: 'NUTRITION' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
                { id: 4, name: 'امراض الرئة', value: 'dentiste', imgSrc: 'PNEUMOLOGIE' },
                { id: 5, name: 'العيون', value: 'dentiste', imgSrc: 'OPHTALMOLOGIE' },
                { id: 6, name: 'أذن أنف حنجرة', value: 'dentiste', imgSrc: 'ORL' },
                { id: 7, name: 'الأعصاب', value: 'dentiste', imgSrc: 'NEUROLOGIE' },
                { id: 8, name: 'الكلي', value: 'dentiste', imgSrc: 'UROLOGIE' },
                { id: 9, name: 'نساء و توليد', value: 'dentiste', imgSrc: 'GYNECOLOGIE_OBSTETRIQUE' },
                { id: 10, name: 'الجهاز الهضمي', value: 'dentiste', imgSrc: 'GASTROLOGIE' },
                { id: 11, name: 'الغدد', value: 'dentiste', imgSrc: 'ENDOCRINOLOGIE' },
                { id: 12, name: 'البشرة', value: 'dentiste', imgSrc: 'DERMATOLOGIE' },
                { id: 13, name: 'القلب', value: 'dentiste', imgSrc: 'CARDIOLOGIE' },
                { id: 14, name: 'النفس', value: 'dentiste', imgSrc: 'PSYCHIATRIE' },
                { id: 15, name: 'التغذية', value: 'dentiste', imgSrc: 'NUTRITION' },    
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},
        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة موعد ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},
                // {id:2, name:' طلب إستشارة ' , icon:'eye' , link:'', bgColor:''},
                // {id:2, name:' بحث عن دواء ' , icon:'eye' , link:'', bgColor:''},
        ],
        profileTarif:true,

    },
    pharmacie: {
        tag: 'pharmacie',
        themeColor: '#6edb8d',
        directoryTable: '01_pharmacie',
        systemActive: true,
        systemName: 'نظام إدارة الصيدليات',
        systemLink: 'https://system.abyedh.tn/Landing/pharmacie',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>المنصة هاذي عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي صيدلية و تنجم تعرف مفتوحة ولا مغلقة و كلنك تلوج علي دواء معين نتجم تعرف بالمسبق موجود ولا لا , دون الحاجة للتنقل ...</h5>',
            '<h5>في المقابل كانك صاحب صيدلية المنصة هاذي توفرك نضام إدارة للصيدلية متاعك و تعاونك باش تكون قريب من زبائنك و مزودي الأدوية اللي تتعامل معاهم بطريقة ساهلة و بسيطة  </h5> ']
        ],
        subCatagSmall: [
            [
                {id:1, name:'ليل', value:'nuit', imgSrc:'nuit'},
                {id:2, name:'نهار', value:'jour', imgSrc:'jour'}
            ]   
        ],
        subCatagLarge:[
            [
                {id:1, name:'ليل', value:'nuit', imgSrc:'nuit'},
                {id:2, name:'نهار', value:'jour', imgSrc:'jour'}
            ]
        ],
        subCateg: [
            {id:1, name:'ليل', value:'nuit', imgSrc:'nuit'},
            {id:2, name:'نهار', value:'jour', imgSrc:'jour'}
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'صيدلية', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' تعمل بـ ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' فريق العمل ', resultTag:'' , icon:'star-half'},
        ],
        profileBtns:[
                {id:1, name:' شراء / موعد   ' , icon:'shop' , link:'Action/pharmacie', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/pharmacie', bgColor:''},
        ],
        profileTarif:true,
    },
    clinique: {
        tag: 'clinique',
        themeColor: '#04c6ce',
        directoryTable: '01_clinique',
        systemActive: true,
        systemName: 'نظام إدارة المصحات الخاصة',
        systemLink: 'https://system.abyedh.tn/Landing/clinique',
        iconName: 'clinique',
        WiconName: 'clinique',
        adsImage: 'clinique',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>كانك نلوج في مصحة ذات جودة خدمات معينة أنت في المكان الصحيح , أبيض توفرلك محرك بحث لجميع أنواع المصحات التونسية باش تعاونك تلقا الوجة اللي حاجتك بيها من أجل خدمات صحية أفضل و أكثر رفاهية </h5>', 
            '<h5>في المقابل أبيض توفر لأصحاب و مديري المصحات الخاصة نظام إدارة و مراقبة و متابعة للمصحة و للحرفاء من أجل تقديم خدمة أفضل و تحسين جودة عملية العلاج و التواصل مع الحرفاء و المرضي بطريقة سهلة و رقمية </h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'نسائية', value: 'femme', imgSrc: 'female' },
                { id: 2, name: 'عقلية', value: 'mentale', imgSrc: 'mentale' },
                { id: 3, name: ' علاجية', value: 'soint', imgSrc: 'logo' },
                { id: 4, name: ' عامة', value: 'generale', imgSrc: 'generale' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'نسائية', value: 'femme', imgSrc: 'female' },
                { id: 2, name: 'عقلية', value: 'mentale', imgSrc: 'mentale' },
                { id: 3, name: ' علاجية', value: 'soint', imgSrc: 'logo' },
                { id: 4, name: ' عامة', value: 'generale', imgSrc: 'generale' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'نسائية', value: 'femme', imgSrc: 'female' },
                { id: 2, name: 'عقلية', value: 'mentale', imgSrc: 'mentale' },
                { id: 3, name: ' علاجية', value: 'soint', imgSrc: 'logo' },
                { id: 4, name: ' عامة', value: 'generale', imgSrc: 'generale' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'مصحة ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' إختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز / تسجيل   ' , icon:'calendar' , link:'Action/clinique', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/clinique', bgColor:''},

        ],
        profileTarif:true,

    },
    labo: {
        tag: 'labo',
        themeColor: '#52a3c9',
        directoryTable: '01_labo',
        systemActive: true,
        systemName: 'نظام إدارة مخبر طبي   ',
        systemLink: 'https://system.abyedh.tn/Landing/labo',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>تلوج في مخبر تحليل ؟ مخبر تشريح ؟ و إلا اي نوع أخر من المخابر الطبية ؟ أبيض توفرلك محرك البحث هاذا اللي تلقا فيه المخبر اللي تلوج عليه و اللي تنجم تاخو مواعيدك و تحاليلك من خلالو بطريقة رقمية</h5>',
            '<h5>في المقابل كلنك صاحب ولا مدير ولا تشتغل في مركز طبي و تلوج علي أداة تكنولوجية تعاونك في أداء عملك بطريقة تضمن تحسين  جودة الخدمة الصحية , فأنت في المكان الصحيح : منصة ابيض للمخابر الطبية</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'تحليل وراثي خلوي', value: 'ANATOMIE_PATHOLOGIE', imgSrc: 'dna' },
                { id: 2, name: 'تحليل بيولوجي طبي', value: 'ANALYSES DE BIOLOGIE', imgSrc: 'blod' },
            ],
            [
                { id: 3, name: ' تشريح وعلم الخلايا', value: 'CYTOGENETIQUE', imgSrc: 'cellule' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'تحليل وراثي خلوي', value: 'ANATOMIE_PATHOLOGIE', imgSrc: 'dna' },
                { id: 2, name: 'تحليل بيولوجي طبي', value: 'ANALYSES DE BIOLOGIE', imgSrc: 'blod' },
                { id: 3, name: ' تشريح وعلم الخلايا', value: 'CYTOGENETIQUE', imgSrc: 'cellule' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'تحليل وراثي خلوي', value: 'ANATOMIE_PATHOLOGIE', imgSrc: 'dna' },
                { id: 2, name: 'تحليل بيولوجي طبي', value: 'ANALYSES DE BIOLOGIE', imgSrc: 'blod' },
                { id: 3, name: ' تشريح وعلم الخلايا', value: 'CYTOGENETIQUE', imgSrc: 'cellule' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'مخبر ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز / تسجيل   ' , icon:'calendar' , link:'Action/labo', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/labo', bgColor:''},

        ],
        profileTarif:true,

    },
    centreMD: {
        tag: 'centreMD',
        themeColor: '#1dd3b0',
        directoryTable: '01_centreMD',
        systemActive: true,
        systemName: 'نظام إدارة المراكز الطبية',
        systemLink: 'https://system.abyedh.tn/Landing/centreMD',
        iconName: 'centreMD',
        WiconName: 'centreMD',
        adsImage: 'centreMD',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>تلوج في مركز تصوير راديولوجي ؟ مركز غسيل كلي ولا مركز علاج بمياه البحر ؟ ولا اي مركز صحي آخر ؟ أبيض يوفرلك محرك البحث اللي يربط بالمنشآت الصحية هاذي و يمكنك أنك تتواصل معاها لتحسين عملية العلاج </h5>',
            '<h5>في المقابل كانك مدير ولا صاحب مركز علاج خاص المنصة هاذي تعاونك بالباهي إنك تدير مركزك الصحي من خلال نظام إدارة ومراقبة و متابعة  رقمي متصلة بجميع الأطراف المتدخلة في عملية العلاج من حرفاء و عاملين و غيرهم ..</h5> ']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'أشعة', value: 'radio', imgSrc: 'radio' },
                { id: 2, name: 'غسيل الكلي', value: 'dialyse', imgSrc: 'dialyse' },
            ],
            [
                { id: 3, name: ' إستشفائي', value: 'sea', imgSrc: 'sea' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'أشعة', value: 'radio', imgSrc: 'radio' },
                { id: 2, name: 'غسيل الكلي', value: 'dialyse', imgSrc: 'dialyse' },
                { id: 3, name: ' إستشفائي', value: 'sea', imgSrc: 'sea' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أشعة', value: 'radio', imgSrc: 'radio' },
                { id: 2, name: 'غسيل الكلي', value: 'dialyse', imgSrc: 'dialyse' },
                { id: 3, name: ' إستشفائي', value: 'sea', imgSrc: 'sea' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'مركز  ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز / تسجيل   ' , icon:'calendar' , link:'Action/centreMD', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/centreMD', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_s_hospital: {
        tag: 'hospital',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>المنصة هاذي تعاونك بالباهي كانك تلوج علي منشأة معينة في مجال الصحة ولا تحب تعرف اوقات عمل الإدارات التونيسة ولا تعرف أي معلومة إرشادية ...</h5>',
            '<h5>في المقابل أي إدارة تنجم تتمتع بنظام إدارة عن بعد يربط بينها و بين المواطن لتسهيل و تبسيط العمليات الإدارية ... </h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مستشفي جامعي', value: 'dentiste', imgSrc: 'hospital' },
                { id: 2, name: 'مستشفي جهوي', value: 'dentiste', imgSrc: 'hospital' },
            ],
            [
                { id: 3, name: ' مستشفي عسكري', value: 'dentiste', imgSrc: 'hospital' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مستشفي جامعي', value: 'dentiste', imgSrc: 'hospital' },
                { id: 2, name: 'مستشفي جهوي', value: 'dentiste', imgSrc: 'hospital' },
                { id: 3, name: ' مستشفي عسكري', value: 'dentiste', imgSrc: 'hospital' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مستشفي جامعي', value: 'dentiste', imgSrc: 'hospital' },
                { id: 2, name: 'مستشفي جهوي', value: 'dentiste', imgSrc: 'hospital' },
                { id: 3, name: ' مستشفي عسكري', value: 'dentiste', imgSrc: 'hospital' },

        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'مستشفي ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' النوع ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الطاقم الطبي ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_s_csb: {
        tag: 'csb',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>المنصة هاذي تعاونك بالباهي كانك تلوج علي منشأة معينة في مجال الصحة ولا تحب تعرف اوقات عمل الإدارات التونيسة ولا تعرف أي معلومة إرشادية ...</h5>',
            '<h5>في المقابل أي إدارة تنجم تتمتع بنظام إدارة عن بعد يربط بينها و بين المواطن لتسهيل و تبسيط العمليات الإدارية ... </h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مستوصف', value: 'dentiste', imgSrc: 'C_soins' },
                { id: 2, name: 'مركز صحة', value: 'dentiste', imgSrc: 'C_soins' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مستوصف', value: 'dentiste', imgSrc: 'C_soins' },
                { id: 2, name: 'مركز صحة', value: 'dentiste', imgSrc: 'C_soins' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مستوصف', value: 'dentiste', imgSrc: 'C_soins' },
                { id: 2, name: 'مركز صحة', value: 'dentiste', imgSrc: 'C_soins' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'مركز صحة', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    /*education*/ 
    garderie: {
        tag: 'garderie',
        themeColor: '#cf208f',
        directoryTable: '02_garderie',
        systemActive: true,
        systemName: 'نظام إدارة روضة أطفال   ',
        systemLink: 'https://system.abyedh.tn/Landing/garderie',
        iconName: 'garderie',
        WiconName: 'garderie',
        adsImage: 'garderie',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>كانك تلوج في روضة مناسبة لصغيرك المنصة هاذي توفر دليل كامل لرياض الأطفال في تونس و تمكنك زادا من التسجيل عن بعد في الروضة و تعطيك الفرصة باش تبقي ديما متصل و متابع لعملية تعلم ولدك ولا بنتك </h5>',
            '<h5>في المقابل كانك صاحب ولا صاحبة رياض أطفال أبيض توفرلك نظام إدارة و متابعة لمختلف الانشطة اللي تصير داخل المؤسسة متاعك , و بالتالي مزيد من التحكم و الإدارة الذكية لجعل عملية التعلم أكثر جودة و تطور .</h5> ']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'تحضيري', value: 'dentiste', imgSrc: 'nursery' },
                { id: 2, name: 'محضنة', value: 'dentiste', imgSrc: 'nurserya' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'تحضيري', value: 'dentiste', imgSrc: 'nursery' },
                { id: 2, name: 'محضنة', value: 'dentiste', imgSrc: 'nurserya' },
            ]
        ],
        subCateg:[
                { id: 1, name: 'تحضيري', value: 'dentiste', imgSrc: 'nursery' },
                { id: 2, name: 'محضنة', value: 'dentiste', imgSrc: 'nurserya' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'إسم الروضة', resultTag:'Name' , icon:'person-circle'},
                {id:1, name:' نوع الروضة ', resultTag:'Genre' , icon:'arrows-move'},
                {id:1, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:1, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:1, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:1, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:1, name:' الطاقم التربوي ', resultTag:'' , icon:'star-half'},
        ],
        profileBtns:[
            {id:1, name:' تسجيل / ترسيم    ' , icon:'edit outline' , link:'Action/garderie', bgColor:''},
            {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/garderie', bgColor:''},
        ],
        profileTarif:true,

    },
    ecole: {
        tag: 'ecole',
        themeColor: '#218281',
        directoryTable: '01_ecole',
        systemActive: true,
        systemName: 'نظام إدارة المدارس الخاصة',
        systemLink: 'https://system.abyedh.tn/Landing/ecole',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>المنصة هاذي تعاونك باش تلقي المؤسسة الخاصة المناسبة لصغيرك, تلقي فيها أغلب المؤسسات التونسسية مع إمكانية التفاعل المباشر مع المؤسسة اللي حاجتك بيها : تسجيل , ترسيم , متابعة الأعداد , المراقبة ...</h5>', 
            '<h5>في المقابل كانك صاحب مؤسسة خاصة منصة أبيض تمكنك من إدارة مؤسستك و متابعة أنشطتها من خلال فضاء يربط بين الإدارة و المدرس و الولي ... بالإضافة لبرنامج حساب الأعداد آليا و أرشفة سحابية لكل ملفات التلاميذ </h5> ']
        ],
        subCatagSmall: [
            [
                {id:1, name:'نظام عربي', value:'nuit', imgSrc:'primaire'},
                {id:2, name:'نظام فرنسي', value:'jour', imgSrc:'primaire'}
            ]   
        ],
        subCatagLarge:[
            [
                {id:1, name:'نظام عربي', value:'nuit', imgSrc:'primaire'},
                {id:2, name:'نظام فرنسي', value:'jour', imgSrc:'primaire'}
            ]
        ],
        subCateg: [
                { id: 1, name: 'نظام عربي', value: 'dentiste', imgSrc: 'primaire' },
                { id: 2, name: 'نظام فرنسي', value: 'dentiste', imgSrc: 'primaire' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:' مدرسة', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الطاقم التربوي  ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:'  تسجيل / ترسيم   ' , icon:'edit outline' , link:'Action/ecole', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/ecole', bgColor:''},

        ],
        profileTarif:true,

    },
    lycee: {
        tag: 'lycee',
        themeColor: '#218281',
        directoryTable: '01_lycee',
        systemActive: true,
        systemName: 'نظام إدارة المعاهد الخاصة',
        systemLink: 'https://system.abyedh.tn/Landing/lycee',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>المنصة هاذي تعاونك باش تلقي المؤسسة الخاصة المناسبة لصغيرك, تلقي فيها أغلب المؤسسات التونسسية مع إمكانية التفاعل المباشر مع المؤسسة اللي حاجتك بيها : تسجيل , ترسيم , متابعة الأعداد , المراقبة ...</h5>', 
            '<h5>في المقابل كانك صاحب مؤسسة خاصة منصة أبيض تمكنك من إدارة مؤسستك و متابعة أنشطتها من خلال فضاء يربط بين الإدارة و المدرس و الولي ... بالإضافة لبرنامج حساب الأعداد آليا و أرشفة سحابية لكل ملفات التلاميذ </h5>']
        ],
        subCatagSmall: [
            [
                {id:1, name:'مدرسة إعدادية', value:'nuit', imgSrc:'college'},
                {id:2, name:'معهد ثانوي', value:'jour', imgSrc:'college'}
            ]   
        ],
        subCatagLarge:[
            [
                {id:1, name:'مدرسة إعدادية', value:'nuit', imgSrc:'college'},
                {id:2, name:'معهد ثانوي', value:'jour', imgSrc:'college'}
            ]
        ],
        subCateg: [
                { id: 1, name: 'مدرسة إعدادية', value: 'dentiste', imgSrc: 'college' },
                { id: 2, name: 'معهد ثانوي', value: 'dentiste', imgSrc: 'college' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'معهد / إعدادية ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' المستوي ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الطاقم التربوي  ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' تسجيل / ترسيم   ' , icon:'edit outline' , link:'Action/lycee', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/lycee', bgColor:''},

        ],
        profileTarif:true,

    },
    universite: {
        tag: 'universite',
        themeColor: '#218281',
        directoryTable: '01_universite',
        systemActive: true,
        systemName: 'نظام إدارة الجامعات الخاصة',
        systemLink: 'https://system.abyedh.tn/Landing/universite',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>المنصة هاذي تعاونك باش تلقي المؤسسة الخاصة المناسبة لصغيرك, تلقي فيها أغلب المؤسسات التونسسية مع إمكانية التفاعل المباشر مع المؤسسة اللي حاجتك بيها : تسجيل , ترسيم , متابعة الأعداد , المراقبة ...</h5>', 
            '<h5>في المقابل كانك صاحب مؤسسة خاصة منصة أبيض تمكنك من إدارة مؤسستك و متابعة أنشطتها من خلال فضاء يربط بين الإدارة و المدرس و الولي ... بالإضافة لبرنامج حساب الأعداد آليا و أرشفة سحابية لكل ملفات التلاميذ </h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'أداب ولغات', value: 'dentiste', imgSrc: 'univ' },
                { id: 2, name: 'علوم إنسانية', value: 'dentiste', imgSrc: 'univ' },
                { id: 3, name: ' علوم طبيعية', value: 'dentiste', imgSrc: 'univ' },
                { id: 4, name: 'حقوق و قانون', value: 'dentiste', imgSrc: 'univ' },
            ],[
                { id: 5, name: 'إقتصاد و تصرف', value: 'dentiste', imgSrc: 'univ' },
                { id: 6, name: ' صيدلة', value: 'dentiste', imgSrc: 'univ' },
                { id: 7, name: 'طب', value: 'dentiste', imgSrc: 'univ' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'أداب ولغات', value: 'dentiste', imgSrc: 'univ' },
                { id: 2, name: 'علوم إنسانية', value: 'dentiste', imgSrc: 'univ' },
                { id: 3, name: ' علوم طبيعية', value: 'dentiste', imgSrc: 'univ' },
                { id: 4, name: 'حقوق و قانون', value: 'dentiste', imgSrc: 'univ' },
                { id: 5, name: 'إقتصاد و تصرف', value: 'dentiste', imgSrc: 'univ' },
                { id: 6, name: ' صيدلة', value: 'dentiste', imgSrc: 'univ' },
                { id: 7, name: 'طب', value: 'dentiste', imgSrc: 'univ' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أداب ولغات', value: 'dentiste', imgSrc: 'univ' },
                { id: 2, name: 'علوم إنسانية', value: 'dentiste', imgSrc: 'univ' },
                { id: 3, name: ' علوم طبيعية', value: 'dentiste', imgSrc: 'univ' },
                { id: 4, name: 'حقوق و قانون', value: 'dentiste', imgSrc: 'univ' },
                { id: 5, name: 'إقتصاد و تصرف', value: 'dentiste', imgSrc: 'univ' },
                { id: 6, name: ' صيدلة', value: 'dentiste', imgSrc: 'univ' },
                { id: 7, name: 'طب', value: 'dentiste', imgSrc: 'univ' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'جامعة', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاصات ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الطاقم التربوي ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' تسجيل / ترسيم   ' , icon:'edit outline' , link:'Action/universite', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/universite', bgColor:''},

        ],
        profileTarif:true,

    },
    impremerie: {
        tag: 'impremerie',
        themeColor: '#4c4a48',
        directoryTable: '01_impremerie',
        systemActive: true,
        systemName: 'نظام إدارة المطابع',
        systemLink: 'https://system.abyedh.tn/Landing/impremerie',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>كانك تلوج في خدمات عامة مناسبة لصغيرك المنصة هاذي توفر دليل كامل لرياض الأطفال في تونس و تمكنك زادا من التسجيل عن بعد في الخدمات عامة و تعطيك الفرصة باش تبقي ديما متصل و متابع لعملية تعلم ولدك ولا بنتك </h5>',
            '<h5>في المقابل كانك صاحب ولا صاحبة رياض أطفال أبيض توفرلك نظام إدارة و متابعة لمختلف الانشطة اللي تصير داخل المؤسسة متاعك , و بالتالي مزيد من التحكم و الإدارة الذكية لجعل عملية التعلم أكثر جودة و تطور .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:' مطبعة', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' النوع ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' نوع الخدمات ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' طباعة / خدمة   ' , icon:'calendar' , link:'Action/impremerie', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/impremerie', bgColor:''},

        ],
        profileTarif:true,

    },
    librairie: {
        tag: 'librairie',
        themeColor: '#4c4a48',
        directoryTable: '01_librairie',
        systemActive: true,
        systemName: 'نظام إدارة الكتبيات',
        systemLink: 'https://system.abyedh.tn/Landing/librairie',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>كانك تلوج في خدمات عامة مناسبة لصغيرك المنصة هاذي توفر دليل كامل لرياض الأطفال في تونس و تمكنك زادا من التسجيل عن بعد في الخدمات عامة و تعطيك الفرصة باش تبقي ديما متصل و متابع لعملية تعلم ولدك ولا بنتك </h5>',
            '<h5>في المقابل كانك صاحب ولا صاحبة رياض أطفال أبيض توفرلك نظام إدارة و متابعة لمختلف الانشطة اللي تصير داخل المؤسسة متاعك , و بالتالي مزيد من التحكم و الإدارة الذكية لجعل عملية التعلم أكثر جودة و تطور .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'كتبية', value: 'dentiste', imgSrc: 'biblio' },
                { id: 2, name: 'أدوات مذرسية', value: 'dentiste', imgSrc: 'biblio' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'كتبية', value: 'dentiste', imgSrc: 'biblio' },
                { id: 2, name: 'أدوات مذرسية', value: 'dentiste', imgSrc: 'biblio' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'كتبية', value: 'dentiste', imgSrc: 'biblio' },
                { id: 2, name: 'أدوات مذرسية', value: 'dentiste', imgSrc: 'biblio' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'كتبية ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' فريق العمل ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' شراء ' , icon:'calendar' , link:'Action/librairie', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/librairie', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_e_centre: {
        tag: 'admin_e_centre',
        themeColor: '#0275c5',
        directoryTable: '01_admin_e_centre',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/admin_e_centre',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>المنصة هاذي تعاونك بالباهي كانك تلوج علي منشأة معينة في مجال التعليم ولا تحب تعرف اوقات عمل الإدارات التونيسة ولا تعرف أي معلومة إرشادية ...</h5>',
            '<h5>في المقابل أي إدارة تنجم تتمتع بنظام إدارة عن بعد يربط بينها و بين المواطن لتسهيل و تبسيط العمليات الإدارية ... </h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'تقنية', value: 'dentiste', imgSrc: 'centref' },
                { id: 2, name: 'مهن', value: 'dentiste', imgSrc: 'centref' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'تقنية', value: 'dentiste', imgSrc: 'centref' },
                { id: 2, name: 'مهن', value: 'dentiste', imgSrc: 'centref' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'تقنية', value: 'dentiste', imgSrc: 'centref' },
                { id: 2, name: 'مهن', value: 'dentiste', imgSrc: 'centref' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'إسم المركز', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الطاقم التربوي ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/admin_e_centre', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/admin_e_centre', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_e_biblio: {
        tag: 'admin_e_biblio',
        themeColor: '#0275c5',
        directoryTable: '01_admin_e_biblio',
        systemActive: false,
        systemName: 'نظام إدارة المكتبات العمومية',
        systemLink: 'https://system.abyedh.tn/Landing/admin_e_biblio',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>المنصة هاذي تعاونك بالباهي كانك تلوج علي منشأة معينة في مجال التعليم ولا تحب تعرف اوقات عمل الإدارات التونيسة ولا تعرف أي معلومة إرشادية ...</h5>', 
            '<h5>في المقابل أي إدارة تنجم تتمتع بنظام إدارة عن بعد يربط بينها و بين المواطن لتسهيل و تبسيط العمليات الإدارية ... </h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مكتبة وطنية', value: 'dentiste', imgSrc: 'Bibliotheque' },
                { id: 2, name: 'مكتبة عمومية', value: 'dentiste', imgSrc: 'Bibliotheque' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مكتبة وطنية', value: 'dentiste', imgSrc: 'Bibliotheque' },
                { id: 2, name: 'مكتبة عمومية', value: 'dentiste', imgSrc: 'Bibliotheque' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مكتبة وطنية', value: 'dentiste', imgSrc: 'Bibliotheque' },
                { id: 2, name: 'مكتبة عمومية', value: 'dentiste', imgSrc: 'Bibliotheque' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'مكتبة', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/admin_e_biblio', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/admin_e_biblio', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_e_ecole: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'م. إبتدائية', value: 'dentiste', imgSrc: 'ecole' },
                { id: 2, name: 'م. إبتذائية', value: 'dentiste', imgSrc: 'ecole' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'م. إبتدائية', value: 'dentiste', imgSrc: 'ecole' },
                { id: 2, name: 'م. إبتذائية', value: 'dentiste', imgSrc: 'ecole' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'م. إبتدائية', value: 'dentiste', imgSrc: 'ecole' },
                { id: 2, name: 'م. إبتذائية', value: 'dentiste', imgSrc: 'ecole' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_e_lycee: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'إعدادي', value: 'dentiste', imgSrc: 'lycee' },
                { id: 2, name: 'ثانوي', value: 'dentiste', imgSrc: 'lycee' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'إعدادي', value: 'dentiste', imgSrc: 'lycee' },
                { id: 2, name: 'ثانوي', value: 'dentiste', imgSrc: 'lycee' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'إعدادي', value: 'dentiste', imgSrc: 'lycee' },
                { id: 2, name: 'ثانوي', value: 'dentiste', imgSrc: 'lycee' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_e_universite: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'أداب ولغات', value: 'dentiste', imgSrc: 'univ' },
                { id: 2, name: 'علوم إنسانية', value: 'dentiste', imgSrc: 'univ' },
                { id: 3, name: ' علوم طبيعية', value: 'dentiste', imgSrc: 'univ' },
                { id: 4, name: 'حقوق و قانون', value: 'dentiste', imgSrc: 'univ' },
            ],[
                { id: 5, name: 'إقتصاد و تصرف', value: 'dentiste', imgSrc: 'univ' },
                { id: 6, name: ' صيدلة', value: 'dentiste', imgSrc: 'univ' },
                { id: 7, name: 'طب', value: 'dentiste', imgSrc: 'univ' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'أداب ولغات', value: 'dentiste', imgSrc: 'univ' },
                { id: 2, name: 'علوم إنسانية', value: 'dentiste', imgSrc: 'univ' },
                { id: 3, name: ' علوم طبيعية', value: 'dentiste', imgSrc: 'univ' },
                { id: 4, name: 'حقوق و قانون', value: 'dentiste', imgSrc: 'univ' },
                { id: 5, name: 'إقتصاد و تصرف', value: 'dentiste', imgSrc: 'univ' },
                { id: 6, name: ' صيدلة', value: 'dentiste', imgSrc: 'univ' },
                { id: 7, name: 'طب', value: 'dentiste', imgSrc: 'univ' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أداب ولغات', value: 'dentiste', imgSrc: 'univ' },
                { id: 2, name: 'علوم إنسانية', value: 'dentiste', imgSrc: 'univ' },
                { id: 3, name: ' علوم طبيعية', value: 'dentiste', imgSrc: 'univ' },
                { id: 4, name: 'حقوق و قانون', value: 'dentiste', imgSrc: 'univ' },
                { id: 5, name: 'إقتصاد و تصرف', value: 'dentiste', imgSrc: 'univ' },
                { id: 6, name: ' صيدلة', value: 'dentiste', imgSrc: 'univ' },
                { id: 7, name: 'طب', value: 'dentiste', imgSrc: 'univ' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_e_ss: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مدرسي', value: 'dentgiste', imgSrc: 'univ' },
                { id: 2, name: 'جامعي', value: 'dentgiste', imgSrc: 'univ' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مدرسي', value: 'dentiste', imgSrc: 'univ' },
                { id: 2, name: 'جامعي', value: 'dentiste', imgSrc: 'univ' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مدرسي', value: 'dentiste', imgSrc: 'univ' },
                { id: 2, name: 'جامعي', value: 'dentiste', imgSrc: 'univ' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /*transportaion*/
    transporteur: {
        tag: 'docteur',
        themeColor: '#be6e70',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'agence', value: 'dentiste', imgSrc: 'tr-agence' },
                { id: 2, name: 'Transporteur', value: 'dentiste', imgSrc: 'transporteur' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'agence', value: 'dentiste', imgSrc: 'tr-agence' },
                { id: 2, name: 'Transporteur', value: 'dentiste', imgSrc: 'transporteur' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'agence', value: 'dentiste', imgSrc: 'tr-agence' },
                { id: 2, name: 'Transporteur', value: 'dentiste', imgSrc: 'transporteur' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    autoecole: {
        tag: 'docteur',
        themeColor: '#1caaa8',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'صنف ب', value: 'dentiste', imgSrc: 'tourism' },
                { id: 2, name: 'كار', value: 'dentiste', imgSrc: 'car' },
                { id: 3, name: 'تاكسي و  لواج', value: 'dentiste', imgSrc: 'taxi' },
                { id: 4, name: 'وزن ثقيل', value: 'dentiste', imgSrc: 'poid' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'صنف ب', value: 'dentiste', imgSrc: 'tourism' },
                { id: 2, name: 'كار', value: 'dentiste', imgSrc: 'car' },
                { id: 3, name: 'تاكسي و  لواج', value: 'dentiste', imgSrc: 'taxi' },
                { id: 4, name: 'وزن ثقيل', value: 'dentiste', imgSrc: 'poid' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'صنف ب', value: 'dentiste', imgSrc: 'tourism' },
                { id: 2, name: 'كار', value: 'dentiste', imgSrc: 'car' },
                { id: 3, name: 'تاكسي و  لواج', value: 'dentiste', imgSrc: 'taxi' },
                { id: 4, name: 'وزن ثقيل', value: 'dentiste', imgSrc: 'poid' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    taxi: {
        tag: 'docteur',
        themeColor: '#c6bb0c',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    louage: {
        tag: 'docteur',
        themeColor: '#5ab7d6',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /*nutrition*/
    cafe: {
        tag: 'docteur',
        themeColor: '#363636',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مقهي', value: 'dentiste', imgSrc: 'populaire' },
                { id: 2, name: 'فطاء عائلي', value: 'dentiste', imgSrc: 'mixte' },
            ],[
                { id: 3, name: 'قاعة شاي', value: 'dentiste', imgSrc: 'tea' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مقهي', value: 'dentiste', imgSrc: 'populaire' },
                { id: 2, name: 'فطاء عائلي', value: 'dentiste', imgSrc: 'mixte' },
                { id: 3, name: 'قاعة شاي', value: 'dentiste', imgSrc: 'tea' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مقهي', value: 'dentiste', imgSrc: 'populaire' },
                { id: 2, name: 'فطاء عائلي', value: 'dentiste', imgSrc: 'mixte' },
                { id: 3, name: 'قاعة شاي', value: 'dentiste', imgSrc: 'tea' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    restaurant: {
        tag: 'docteur',
        themeColor: '#35ac67',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: '5 نجوم', value: 'dentiste', imgSrc: 'kaftaji' },
                { id: 2, name: 'أكلة خفيفة', value: 'dentiste', imgSrc: 'resto1' },
                { id: 3, name: 'ملاوي', value: 'dentiste', imgSrc: 'mlawi' },
                { id: 4, name: ' بتزا', value: 'dentiste', imgSrc: 'pizza' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: ' 5 نجوم', value: 'dentiste', imgSrc: 'kaftaji' },
                { id: 2, name: 'أكلة خفيفة', value: 'dentiste', imgSrc: 'resto1' },
                { id: 3, name: 'ملاوي', value: 'dentiste', imgSrc: 'mlawi' },
                { id: 4, name: ' بتزا', value: 'dentiste', imgSrc: 'pizza' },
            ]
        ],
        subCateg: [
                { id: 1, name: '5 نجوم', value: 'dentiste', imgSrc: 'kaftaji' },
                { id: 2, name: 'أكلة خفيفة', value: 'dentiste', imgSrc: 'resto1' },
                { id: 3, name: 'ملاوي', value: 'dentiste', imgSrc: 'mlawi' },
                { id: 4, name: ' بتزا', value: 'dentiste', imgSrc: 'pizza' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز / طلب   ' , icon:'calendar' , link:'Action/restaurant', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/restaurant', bgColor:''},

        ],
        profileTarif:true,

    },
    ptvente_shop: {
        tag: 'docteur',
        themeColor: '#5e7968',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'magazin', value: 'dentiste', imgSrc: 'bread' },
                { id: 2, name: 'superette', value: 'dentiste', imgSrc: 'bread' },
            ],[
                { id: 3, name: 'عطار ', value: 'dentiste', imgSrc: 'bread' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'magazin', value: 'dentiste', imgSrc: 'bread' },
                { id: 2, name: 'superette', value: 'dentiste', imgSrc: 'bread' },
                { id: 3, name: 'عطار ', value: 'dentiste', imgSrc: 'bread' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'magazin', value: 'dentiste', imgSrc: 'bread' },
                { id: 2, name: 'superette', value: 'dentiste', imgSrc: 'bread' },
                { id: 3, name: 'عطار ', value: 'dentiste', imgSrc: 'bread' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/restaurant', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/restaurant', bgColor:''},

        ],
        profileTarif:true,

    },
    ptvente_boulengerie: {
        tag: 'docteur',
        themeColor: '#5e7968',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'طابونة', value: 'dentiste', imgSrc: 'pain' },
                { id: 2, name: 'Baguette', value: 'dentiste', imgSrc: 'pain' },
            ],[
                { id: 3, name: ' عربي', value: 'dentiste', imgSrc: 'pain' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'طابونة', value: 'dentiste', imgSrc: 'pain' },
                { id: 2, name: 'Baguette', value: 'dentiste', imgSrc: 'pain' },
                { id: 3, name: ' عربي', value: 'dentiste', imgSrc: 'pain' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'طابونة', value: 'dentiste', imgSrc: 'pain' },
                { id: 2, name: 'Baguette', value: 'dentiste', imgSrc: 'pain' },
                { id: 3, name: ' عربي', value: 'dentiste', imgSrc: 'pain' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    ptvente_viande: {
        tag: 'docteur',
        themeColor: '#5e7968',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'لحوم حمراء', value: 'dentiste', imgSrc: 'viande' },
                { id: 2, name: 'سكالوب', value: 'dentiste', imgSrc: 'viande' },
                { id: 3, name: 'مزرعة', value: 'dentiste', imgSrc: 'viande' },
                { id: 4, name: ' سمك', value: 'dentiste', imgSrc: 'viande' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'لحوم حمراء', value: 'dentiste', imgSrc: 'viande' },
                { id: 2, name: 'سكالوب', value: 'dentiste', imgSrc: 'viande' },
                { id: 3, name: 'مزرعة', value: 'dentiste', imgSrc: 'viande' },
                { id: 4, name: ' سمك', value: 'dentiste', imgSrc: 'viande' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'لحوم حمراء', value: 'dentiste', imgSrc: 'viande' },
                { id: 2, name: 'سكالوب', value: 'dentiste', imgSrc: 'viande' },
                { id: 3, name: 'مزرعة', value: 'dentiste', imgSrc: 'viande' },
                { id: 4, name: ' سمك', value: 'dentiste', imgSrc: 'viande' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    ptvente_fruit: {
        tag: 'docteur',
        themeColor: '#5e7968',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'خضر', value: 'dentiste', imgSrc: 'fruit' },
                { id: 2, name: 'غلال', value: 'dentiste', imgSrc: 'fruit' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'خضر', value: 'dentiste', imgSrc: 'fruit' },
                { id: 2, name: 'غلال', value: 'dentiste', imgSrc: 'fruit' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'خضر', value: 'dentiste', imgSrc: 'fruit' },
                { id: 2, name: 'غلال', value: 'dentiste', imgSrc: 'fruit' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    ptvente_patesserie: {
        tag: 'docteur',
        themeColor: '#5e7968',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'Croissant', value: 'dentiste', imgSrc: 'patt' },
                { id: 2, name: 'Gateaux', value: 'dentiste', imgSrc: 'patt' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'Croissant', value: 'dentiste', imgSrc: 'patt' },
                { id: 2, name: 'Gateaux', value: 'dentiste', imgSrc: 'patt' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'Croissant', value: 'dentiste', imgSrc: 'patt' },
                { id: 2, name: 'Gateaux', value: 'dentiste', imgSrc: 'patt' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    ptvente_small_shop: {
        tag: 'docteur',
        themeColor: '#5e7968',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'سجائر', value: 'dentiste', imgSrc: 'hmas' },
                { id: 2, name: 'بقول', value: 'dentiste', imgSrc: 'hmas' },
            ],[
                { id: 3, name: ' فواكه جافة', value: 'dentiste', imgSrc: 'hmas' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'سجائر', value: 'dentiste', imgSrc: 'hmas' },
                { id: 2, name: 'بقول', value: 'dentiste', imgSrc: 'hmas' },
                { id: 3, name: ' فواكه جافة', value: 'dentiste', imgSrc: 'hmas' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'سجائر', value: 'dentiste', imgSrc: 'hmas' },
                { id: 2, name: 'بقول', value: 'dentiste', imgSrc: 'hmas' },
                { id: 3, name: ' فواكه جافة', value: 'dentiste', imgSrc: 'hmas' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /*houseCar*/
    house_electro: {
        tag: 'docteur',
        themeColor: '#0078d7',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة نقطة بيع الإلكترونيات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: 'house_electro',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>تلوج في خدمات مختلفة للمنزل متاعك ؟ أبيض تمكنك أنك تلقي المنتجات اللي تحتاجها للمنزل الكل : آلات كهربيائية , مفروشات متنوعة و تمكنك تختار المنتج بالخاصيات اللي تحب عليها ببساطة و سهولة </h5>', 
            '<h5>في المقابل كانك صاحب محل بيع منتجات منزلية المنصة هاذي توفرلك النظام اللي تحتاجو باش تدير العمل متاعك بصفة رقمية و تعاونك تتصل بالحرفاء و المزودين بسهولة و سرعة </h5> ']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'أجهزة كهرومنزلية', value: 'electro', imgSrc: 'electro' },
                { id: 2, name: 'هواتف و حواسيب', value: 'electro', imgSrc: 'electro' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'أجهزة كهرومنزلية', value: 'electro', imgSrc: 'electro' },
                { id: 2, name: 'هواتف و حواسيب', value: 'electro', imgSrc: 'electro' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'أجهزة كهرومنزلية', value: 'electro', imgSrc: 'electro' },
            { id: 2, name: 'هواتف و حواسيب', value: 'electro', imgSrc: 'electro' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    house_meuble: {
        tag: 'docteur',
        themeColor: '#0078d7',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'أثاث منزلي', value: 'fourniture', imgSrc: 'furniture' },
                { id: 2, name: 'أثاث مكتبي', value: 'fourniture', imgSrc: 'furniture' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'أثاث منزلي', value: 'fourniture', imgSrc: 'furniture' },
                { id: 2, name: 'أثاث مكتبي', value: 'fourniture', imgSrc: 'furniture' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'أثاث منزلي', value: 'fourniture', imgSrc: 'furniture' },
            { id: 2, name: 'أثاث مكتبي', value: 'fourniture', imgSrc: 'furniture' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    car_location: {
        tag: 'car_location',
        themeColor: '#2d4664',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'كراء السيارت', value: 'dentiste', imgSrc: 'car_selling' },
                { id: 2, name: 'كراء الشاحنات', value: 'dentiste', imgSrc: 'car_selling' },
            ],
            [
                { id: 3, name: 'كراء الدراجات', value: 'dentiste', imgSrc: 'car_selling' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'كراء السيارت', value: 'dentiste', imgSrc: 'car_selling' },
                { id: 2, name: 'كراء الشاحنات', value: 'dentiste', imgSrc: 'car_selling' },
                { id: 3, name: 'كراء الدراجات', value: 'dentiste', imgSrc: 'car_selling' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'كراء السيارت', value: 'dentiste', imgSrc: 'car_selling' },
                { id: 2, name: 'كراء الشاحنات', value: 'dentiste', imgSrc: 'car_selling' },
                { id: 3, name: 'كراء الدراجات', value: 'dentiste', imgSrc: 'car_selling' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    car_parking: {
        tag: 'docteur',
        themeColor: '#2d4664',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مأوي عمومي', value: 'dentiste', imgSrc: 'parking' },
                { id: 2, name: 'مأوي خاص', value: 'dentiste', imgSrc: 'parking' }, 
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مأوي عمومي', value: 'dentiste', imgSrc: 'parking' },
                { id: 2, name: 'مأوي خاص', value: 'dentiste', imgSrc: 'parking' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مأوي عمومي', value: 'dentiste', imgSrc: 'parking' },
                { id: 2, name: 'مأوي خاص', value: 'dentiste', imgSrc: 'parking' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    car_qiosque: {
        tag: 'docteur',
        themeColor: '#2d4664',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'Qiosque', value: 'dentiste', imgSrc: 'qiosque' },
                { id: 2, name: 'غسيل السيارات', value: 'dentiste', imgSrc: 'qiosque' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'Qiosque', value: 'dentiste', imgSrc: 'qiosque' },
                { id: 2, name: 'غسيل السيارات', value: 'dentiste', imgSrc: 'qiosque' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'Qiosque', value: 'dentiste', imgSrc: 'qiosque' },
                { id: 2, name: 'غسيل السيارات', value: 'dentiste', imgSrc: 'qiosque' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    car_mecanicien: {
        tag: 'docteur',
        themeColor: '#2d4664',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'ميكانيك السيارات', value: 'dentiste', imgSrc: 'car_selling' },
                { id: 2, name: 'ميكانيك الدراجات', value: 'dentiste', imgSrc: 'car_selling' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'ميكانيك السيارات', value: 'dentiste', imgSrc: 'car_selling' },
                { id: 2, name: 'ميكانيك الدراجات', value: 'dentiste', imgSrc: 'car_selling' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'ميكانيك السيارات', value: 'dentiste', imgSrc: 'car_selling' },
                { id: 2, name: 'ميكانيك الدراجات', value: 'dentiste', imgSrc: 'car_selling' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /*construction*/
    samsar: {
        tag: 'docteur',
        themeColor: '#455b7a',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'للكراء', value: 'dentiste', imgSrc: 'studio' },
                { id: 2, name: 'شراء', value: 'dentiste', imgSrc: 'garage' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'للكراء', value: 'dentiste', imgSrc: 'studio' },
                { id: 2, name: 'شراء', value: 'dentiste', imgSrc: 'garage' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'للكراء', value: 'dentiste', imgSrc: 'studio' },
            { id: 2, name: 'شراء', value: 'dentiste', imgSrc: 'garage' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    chantier_contrateur: {
        tag: 'docteur',
        themeColor: '#406163',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'شركة مقاولات', value: 'dentiste', imgSrc: 'moukawel' },
                { id: 2, name: 'مقاول', value: 'dentiste', imgSrc: 'moukawel' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'شركة مقاولات', value: 'dentiste', imgSrc: 'moukawel' },
                { id: 2, name: 'مقاول', value: 'dentiste', imgSrc: 'moukawel' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'شركة مقاولات', value: 'dentiste', imgSrc: 'moukawel' },
            { id: 2, name: 'مقاول', value: 'dentiste', imgSrc: 'moukawel' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    chantier_architecture: {
        tag: 'docteur',
        themeColor: '#406163',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'شركة', value: 'dentiste', imgSrc: 'architect' },
                { id: 2, name: 'مكتب مهندس', value: 'dentiste', imgSrc: 'architect' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'شركة', value: 'dentiste', imgSrc: 'architect' },
                { id: 2, name: 'مكتب مهندس', value: 'dentiste', imgSrc: 'architect' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'شركة', value: 'dentiste', imgSrc: 'architect' },
            { id: 2, name: 'مكتب مهندس', value: 'dentiste', imgSrc: 'architect' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    chantier_quincaillerie: {
        tag: 'docteur',
        themeColor: '#406163',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'قطع غيار', value: 'dentiste', imgSrc: 'truck' },
                { id: 2, name: 'quincaillerie', value: 'dentiste', imgSrc: 'truck' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'قطع غيار', value: 'dentiste', imgSrc: 'truck' },
                { id: 2, name: 'quincaillerie', value: 'dentiste', imgSrc: 'truck' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'قطع غيار', value: 'dentiste', imgSrc: 'truck' },
            { id: 2, name: 'quincaillerie', value: 'dentiste', imgSrc: 'truck' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    handmade_forgeron: {
        tag: 'docteur',
        themeColor: '#cdb556',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'حداد', value: 'dentiste', imgSrc: 'logo10' },
                { id: 2, name: 'ورشة حدادة', value: 'dentiste', imgSrc: 'logo10' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'حداد', value: 'dentiste', imgSrc: 'logo10' },
                { id: 2, name: 'ورشة حدادة', value: 'dentiste', imgSrc: 'logo10' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'حداد', value: 'dentiste', imgSrc: 'logo10' },
            { id: 2, name: 'ورشة حدادة', value: 'dentiste', imgSrc: 'logo10' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    handmade_menuisier: {
        tag: 'docteur',
        themeColor: '#cdb556',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'نجار', value: 'dentiste', imgSrc: 'logo17' },
                { id: 2, name: 'ورشة نجارة', value: 'dentiste', imgSrc: 'logo17' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'نجار', value: 'dentiste', imgSrc: 'logo17' },
                { id: 2, name: 'ورشة نجارة', value: 'dentiste', imgSrc: 'logo17' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'نجار', value: 'dentiste', imgSrc: 'logo17' },
            { id: 2, name: 'ورشة نجارة', value: 'dentiste', imgSrc: 'logo17' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    handmade_peinture: {
        tag: 'docteur',
        themeColor: '#cdb556',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    handmade_electricien: {
        tag: 'docteur',
        themeColor: '#cdb556',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    handmade_plombier: {
        tag: 'docteur',
        themeColor: '#cdb556',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    handmade_cristal: {
        tag: 'docteur',
        themeColor: '#cdb556',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    handmade_marbre: {
        tag: 'docteur',
        themeColor: '#cdb556',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /*life*/
    coiffure: {
        tag: 'docteur',
        themeColor: '#0b97bf',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'رجال', value: 'dentiste', imgSrc: 'coiffure-man' },
                { id: 2, name: 'نساء', value: 'dentiste', imgSrc: 'woumen' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'رجال', value: 'dentiste', imgSrc: 'coiffure-man' },
                { id: 2, name: 'نساء', value: 'dentiste', imgSrc: 'woumen' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'رجال', value: 'dentiste', imgSrc: 'coiffure-man' },
            { id: 2, name: 'نساء', value: 'dentiste', imgSrc: 'woumen' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    boutique: {
        tag: 'docteur',
        themeColor: '#b146c2',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'رجال', value: 'dentiste', imgSrc: 'man' },
                { id: 2, name: 'نساء', value: 'dentiste', imgSrc: 'woumen' },
                { id: 3, name: 'صغار', value: 'dentiste', imgSrc: 'child' },
                { id: 4, name: 'أحذية', value: 'dentiste', imgSrc: 'shoes' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'رجال', value: 'dentiste', imgSrc: 'man' },
                { id: 2, name: 'نساء', value: 'dentiste', imgSrc: 'woumen' },
                { id: 3, name: 'صغار', value: 'dentiste', imgSrc: 'child' },
                { id: 4, name: 'أحذية', value: 'dentiste', imgSrc: 'shoes' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'رجال', value: 'dentiste', imgSrc: 'man' },
            { id: 2, name: 'نساء', value: 'dentiste', imgSrc: 'woumen' },
            { id: 3, name: 'صغار', value: 'dentiste', imgSrc: 'child' },
            { id: 4, name: 'أحذية', value: 'dentiste', imgSrc: 'shoes' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    wedding_salon_marriage: {
        tag: 'docteur',
        themeColor: '#c30052',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'قاعة  مغطاة', value: 'dentiste', imgSrc: 'sallon' },
                { id: 2, name: 'قاعة  مفتوحة', value: 'dentiste', imgSrc: 'sallon' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'قاعة  مغطاة', value: 'dentiste', imgSrc: 'sallon' },
                { id: 2, name: 'قاعة  مفتوحة', value: 'dentiste', imgSrc: 'sallon' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'قاعة  مغطاة', value: 'dentiste', imgSrc: 'sallon' },
            { id: 2, name: 'قاعة  مفتوحة', value: 'dentiste', imgSrc: 'sallon' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    wedding_orchestre: {
        tag: 'docteur',
        themeColor: '#c30052',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'فرقة شعبية', value: 'dentiste', imgSrc: 'orqustre' },
                { id: 2, name: 'فنان', value: 'dentiste', imgSrc: 'orqustre' },
            ],
            [
                { id: 3, name: 'أوركستر', value: 'dentiste', imgSrc: 'orqustre' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'فرقة شعبية', value: 'dentiste', imgSrc: 'orqustre' },
                { id: 2, name: 'فنان', value: 'dentiste', imgSrc: 'orqustre' },
                { id: 3, name: 'أوركستر', value: 'dentiste', imgSrc: 'orqustre' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'فرقة شعبية', value: 'dentiste', imgSrc: 'orqustre' },
            { id: 2, name: 'فنان', value: 'dentiste', imgSrc: 'orqustre' },
            { id: 3, name: 'أوركستر', value: 'dentiste', imgSrc: 'orqustre' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    wedding_chef: {
        tag: 'docteur',
        themeColor: '#c30052',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبخ أجنبي', value: 'dentiste', imgSrc: 'chef' },
                { id: 2, name: 'المطبخ التونسي', value: 'dentiste', imgSrc: 'chef' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبخ أجنبي', value: 'dentiste', imgSrc: 'chef' },
                { id: 2, name: 'المطبخ التونسي', value: 'dentiste', imgSrc: 'chef' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'مطبخ أجنبي', value: 'dentiste', imgSrc: 'chef' },
            { id: 2, name: 'المطبخ التونسي', value: 'dentiste', imgSrc: 'chef' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    wedding_photographe: {
        tag: 'docteur',
        themeColor: '#c30052',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'تصوير أعراس', value: 'dentiste', imgSrc: 'photographe' },
                { id: 2, name: 'مصور فوتوغرافي', value: 'dentiste', imgSrc: 'photographe' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'تصوير أعراس', value: 'dentiste', imgSrc: 'photographe' },
                { id: 2, name: 'مصور فوتوغرافي', value: 'dentiste', imgSrc: 'photographe' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'تصوير أعراس', value: 'dentiste', imgSrc: 'photographe' },
            { id: 2, name: 'مصور فوتوغرافي', value: 'dentiste', imgSrc: 'photographe' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    wedding_fourniture_marriage: {
        tag: 'docteur',
        themeColor: '#c30052',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'لوازم مادية', value: 'dentiste', imgSrc: 'lawazem' },
                { id: 2, name: 'فساتين', value: 'dentiste', imgSrc: 'lawazem' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'لوازم مادية', value: 'dentiste', imgSrc: 'lawazem' },
                { id: 2, name: 'فساتين', value: 'dentiste', imgSrc: 'lawazem' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'لوازم مادية', value: 'dentiste', imgSrc: 'lawazem' },
            { id: 2, name: 'فساتين', value: 'dentiste', imgSrc: 'lawazem' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    wedding_bijoux: {
        tag: 'docteur',
        themeColor: '#c30052',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مجوهرات جاهزة', value: 'dentiste', imgSrc: 'bijoux' },
                { id: 2, name: 'صايغي', value: 'dentiste', imgSrc: 'bijoux' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مجوهرات جاهزة', value: 'dentiste', imgSrc: 'bijoux' },
                { id: 2, name: 'صايغي', value: 'dentiste', imgSrc: 'bijoux' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'مجوهرات جاهزة', value: 'dentiste', imgSrc: 'bijoux' },
            { id: 2, name: 'صايغي', value: 'dentiste', imgSrc: 'bijoux' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /*culture */
    gym: {
        tag: 'docteur',
        themeColor: '#7aadab',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'GYM', value: 'dentiste', imgSrc: 'gym' },
                { id: 2, name: 'رياضات فردية', value: 'dentiste', imgSrc: 'karate' },
            ],[
                { id: 3, name: ' متعدد الإختصاصات', value: 'dentiste', imgSrc: 'kickboking' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'GYM', value: 'dentiste', imgSrc: 'gym' },
                { id: 2, name: 'رياضات فردية', value: 'dentiste', imgSrc: 'karate' },
                { id: 3, name: ' متعدد الإختصاصات', value: 'dentiste', imgSrc: 'kickboking' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'GYM', value: 'dentiste', imgSrc: 'gym' },
                { id: 2, name: 'رياضات فردية', value: 'dentiste', imgSrc: 'karate' },
                { id: 3, name: ' متعدد الإختصاصات', value: 'dentiste', imgSrc: 'kickboking' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    pyscine: {
        tag: 'docteur',
        themeColor: '#009fe3',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مغطي', value: 'dentiste', imgSrc: 'closed' },
                { id: 2, name: 'مفتوح', value: 'dentiste', imgSrc: 'open' },
            ],[
                { id: 3, name: ' للأطفال', value: 'dentiste', imgSrc: 'childpool' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مغطي', value: 'dentiste', imgSrc: 'closed' },
                { id: 2, name: 'مفتوح', value: 'dentiste', imgSrc: 'open' },
                { id: 3, name: ' للأطفال', value: 'dentiste', imgSrc: 'childpool' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مغطي', value: 'dentiste', imgSrc: 'closed' },
                { id: 2, name: 'مفتوح', value: 'dentiste', imgSrc: 'open' },
                { id: 3, name: ' للأطفال', value: 'dentiste', imgSrc: 'childpool' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    stade: {
        tag: 'docteur',
        themeColor: '#587e6d',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'كرة قدم', value: 'dentiste', imgSrc: 'foot' },
                { id: 2, name: 'كرة سلة', value: 'dentiste', imgSrc: 'basquette' },
                { id: 3, name: 'كرة الطائرة ', value: 'dentiste', imgSrc: 'voley' },
                { id: 4, name: ' كرة تنس', value: 'dentiste', imgSrc: 'tenis' },
            ],[
                { id: 5, name: ' رقبي', value: 'dentiste', imgSrc: 'regby' },
                { id: 6, name: ' جولف', value: 'dentiste', imgSrc: 'golf' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'كرة قدم', value: 'dentiste', imgSrc: 'foot' },
                { id: 2, name: 'كرة سلة', value: 'dentiste', imgSrc: 'basquette' },
                { id: 3, name: 'كرة الطائرة ', value: 'dentiste', imgSrc: 'voley' },
                { id: 4, name: ' كرة تنس', value: 'dentiste', imgSrc: 'tenis' },
                { id: 5, name: ' رقبي', value: 'dentiste', imgSrc: 'regby' },
                { id: 6, name: ' جولف', value: 'dentiste', imgSrc: 'golf' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'كرة قدم', value: 'dentiste', imgSrc: 'foot' },
                { id: 2, name: 'كرة سلة', value: 'dentiste', imgSrc: 'basquette' },
                { id: 3, name: 'كرة الطائرة ', value: 'dentiste', imgSrc: 'voley' },
                { id: 4, name: ' كرة تنس', value: 'dentiste', imgSrc: 'tenis' },
                { id: 5, name: ' رقبي', value: 'dentiste', imgSrc: 'regby' },
                { id: 6, name: ' جولف', value: 'dentiste', imgSrc: 'golf' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    art_cinema: {
        tag: 'docteur',
        themeColor: '#2c7177',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'قاعة عرض', value: 'dentiste', imgSrc: 'cima' },
                { id: 2, name: 'قاعة سنما', value: 'dentiste', imgSrc: 'cima' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'قاعة عرض', value: 'dentiste', imgSrc: 'cima' },
                { id: 2, name: 'قاعة سنما', value: 'dentiste', imgSrc: 'cima' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'قاعة عرض', value: 'dentiste', imgSrc: 'cima' },
                { id: 2, name: 'قاعة سنما', value: 'dentiste', imgSrc: 'cima' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    art_theatre: {
        tag: 'docteur',
        themeColor: '#2c7177',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مسرح مفتوح', value: 'dentiste', imgSrc: 'theatre' },
                { id: 2, name: 'مسرح مغلق', value: 'dentiste', imgSrc: 'theatre' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مسرح مفتوح', value: 'dentiste', imgSrc: 'theatre' },
                { id: 2, name: 'مسرح مغلق', value: 'dentiste', imgSrc: 'theatre' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مسرح مفتوح', value: 'dentiste', imgSrc: 'theatre' },
                { id: 2, name: 'مسرح مغلق', value: 'dentiste', imgSrc: 'theatre' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    art_musee: {
        tag: 'docteur',
        themeColor: '#2c7177',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مكان أثري', value: 'dentiste', imgSrc: 'Musee' },
                { id: 2, name: 'متحف', value: 'dentiste', imgSrc: 'Musee' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مكان أثري', value: 'dentiste', imgSrc: 'Musee' },
                { id: 2, name: 'متحف', value: 'dentiste', imgSrc: 'Musee' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'مكان أثري', value: 'dentiste', imgSrc: 'Musee' },
                { id: 2, name: 'متحف', value: 'dentiste', imgSrc: 'Musee' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_c_mj: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'دار شباب', value: 'dentiste', imgSrc: 'Msjeune' },
                { id: 2, name: 'دار شباب', value: 'dentiste', imgSrc: 'Msjeune' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'دار شباب', value: 'dentiste', imgSrc: 'Msjeune' },
                { id: 2, name: 'دار شباب', value: 'dentiste', imgSrc: 'Msjeune' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'دار شباب', value: 'dentiste', imgSrc: 'Msjeune' },
                { id: 2, name: 'دار شباب', value: 'dentiste', imgSrc: 'Msjeune' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_c_mc: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'دار ثقافة', value: 'dentiste', imgSrc: 'Mculture' },
                { id: 2, name: 'دار ثقافة', value: 'dentiste', imgSrc: 'Mculture' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'دار ثقافة', value: 'dentiste', imgSrc: 'Mculture' },
                { id: 2, name: 'دار ثقافة', value: 'dentiste', imgSrc: 'Mculture' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'دار ثقافة', value: 'dentiste', imgSrc: 'Mculture' },
                { id: 2, name: 'دار ثقافة', value: 'dentiste', imgSrc: 'Mculture' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_c_me: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'نادي أطفال', value: 'dentiste', imgSrc: 'ClubEnf' },
                { id: 2, name: 'نادي أطفال', value: 'dentiste', imgSrc: 'ClubEnf' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'نادي أطفال', value: 'dentiste', imgSrc: 'ClubEnf' },
                { id: 2, name: 'نادي أطفال', value: 'dentiste', imgSrc: 'ClubEnf' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'نادي أطفال', value: 'dentiste', imgSrc: 'ClubEnf' },
                { id: 2, name: 'نادي أطفال', value: 'dentiste', imgSrc: 'ClubEnf' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /*politique */
    avocat: {
        tag: 'docteur',
        themeColor: '#7a8890',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'تمرين', value: 'dentiste', imgSrc: 'avo1' },
                { id: 2, name: 'تعقيب', value: 'dentiste', imgSrc: 'avo2' },
            ],
            [
                { id: 3, name: 'إستئناف', value: 'dentiste', imgSrc: 'avo3' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'تمرين', value: 'dentiste', imgSrc: 'avo1' },
                { id: 2, name: 'تعقيب', value: 'dentiste', imgSrc: 'avo2' },
                { id: 3, name: 'إستئناف', value: 'dentiste', imgSrc: 'avo3' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'تمرين', value: 'dentiste', imgSrc: 'avo1' },
            { id: 2, name: 'تعقيب', value: 'dentiste', imgSrc: 'avo2' },
            { id: 3, name: 'إستئناف', value: 'dentiste', imgSrc: 'avo3' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /*finance */
    storage: {
        tag: 'docteur',
        themeColor: '#6f858f',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مواد غذائية', value: 'dentiste', imgSrc: 'storage-nutrition' },
                { id: 2, name: 'مواد بناء', value: 'dentiste', imgSrc: 'constraction' },
                { id: 3, name: 'مواد طبية', value: 'dentiste', imgSrc: 'medical' },
                { id: 4, name: 'ملابس', value: 'dentiste', imgSrc: 'clothes' },
            ],
            [
                { id: 5, name: 'مشروبات', value: 'dentiste', imgSrc: 'drink' },
                { id: 6, name: 'خضر غلال', value: 'dentiste', imgSrc: 'fruit' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مواد غذائية', value: 'dentiste', imgSrc: 'storage-nutrition' },
                { id: 2, name: 'مواد بناء', value: 'dentiste', imgSrc: 'constraction' },
                { id: 3, name: 'مواد طبية', value: 'dentiste', imgSrc: 'medical' },
                { id: 4, name: 'ملابس', value: 'dentiste', imgSrc: 'clothes' },
                { id: 5, name: 'مشروبات', value: 'dentiste', imgSrc: 'drink' },
                { id: 6, name: 'خضر غلال', value: 'dentiste', imgSrc: 'fruit' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'مواد غذائية', value: 'dentiste', imgSrc: 'storage-nutrition' },
            { id: 2, name: 'مواد بناء', value: 'dentiste', imgSrc: 'constraction' },
            { id: 3, name: 'مواد طبية', value: 'dentiste', imgSrc: 'medical' },
            { id: 4, name: 'ملابس', value: 'dentiste', imgSrc: 'clothes' },
            { id: 5, name: 'مشروبات', value: 'dentiste', imgSrc: 'drink' },
            { id: 6, name: 'خضر غلال', value: 'dentiste', imgSrc: 'fruit' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    comptable: {
        tag: 'docteur',
        themeColor: '#a77a51',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'تدقيق محاسب', value: 'dentiste', imgSrc: 'compt-bureaux' },
                { id: 2, name: 'محاسب', value: 'dentiste', imgSrc: 'compt-logo' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'تدقيق محاسب', value: 'dentiste', imgSrc: 'compt-bureaux' },
                { id: 2, name: 'محاسب', value: 'dentiste', imgSrc: 'compt-logo' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'تدقيق محاسب', value: 'dentiste', imgSrc: 'compt-bureaux' },
            { id: 2, name: 'محاسب', value: 'dentiste', imgSrc: 'compt-logo' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    socite: {
        tag: 'docteur',
        themeColor: '#32a6c9',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'بنوك', value: 'dentiste', imgSrc: 'bank' },
                { id: 2, name: 'صناعات غذائية', value: 'dentiste', imgSrc: 'alimentaire' },
                { id: 3, name: 'بناء و أنشاء', value: 'dentiste', imgSrc: 'construc' },
                { id: 4, name: 'نسيج', value: 'dentiste', imgSrc: 'textile' },
            ],
            [
                { id: 5, name: 'نقل', value: 'dentiste', imgSrc: 'transp' },
                { id: 6, name: 'تقنية', value: 'dentiste', imgSrc: 'teck' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'بنوك', value: 'dentiste', imgSrc: 'bank' },
                { id: 2, name: 'صناعات غذائية', value: 'dentiste', imgSrc: 'alimentaire' },
                { id: 3, name: 'بناء و أنشاء', value: 'dentiste', imgSrc: 'construc' },
                { id: 4, name: 'نسيج', value: 'dentiste', imgSrc: 'textile' },
                { id: 5, name: 'نقل', value: 'dentiste', imgSrc: 'transp' },
                { id: 6, name: 'تقنية', value: 'dentiste', imgSrc: 'teck' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'بنوك', value: 'dentiste', imgSrc: 'bank' },
            { id: 2, name: 'صناعات غذائية', value: 'dentiste', imgSrc: 'alimentaire' },
            { id: 3, name: 'بناء و أنشاء', value: 'dentiste', imgSrc: 'construc' },
            { id: 4, name: 'نسيج', value: 'dentiste', imgSrc: 'textile' },
            { id: 5, name: 'نقل', value: 'dentiste', imgSrc: 'transp' },
            { id: 6, name: 'تقنية', value: 'dentiste', imgSrc: 'teck' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_f_poste: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مكتب بريد', value: 'dentiste', imgSrc: 'Poste' },
                { id: 2, name: 'مكتب مركزي', value: 'dentiste', imgSrc: 'Poste' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مكتب بريد', value: 'dentiste', imgSrc: 'Poste' },
                { id: 2, name: 'مكتب مركزي', value: 'dentiste', imgSrc: 'Poste' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'مكتب بريد', value: 'dentiste', imgSrc: 'Poste' },
            { id: 2, name: 'مكتب مركزي', value: 'dentiste', imgSrc: 'Poste' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_f_rf: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مكتب مراقبة', value: 'dentiste', imgSrc: 'Recipe' },
                { id: 2, name: 'قباضة مالية', value: 'dentiste', imgSrc: 'Recipe' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مكتب مراقبة', value: 'dentiste', imgSrc: 'Recipe' },
                { id: 2, name: 'قباضة مالية', value: 'dentiste', imgSrc: 'Recipe' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'مكتب مراقبة', value: 'dentiste', imgSrc: 'Recipe' },
            { id: 2, name: 'قباضة مالية', value: 'dentiste', imgSrc: 'Recipe' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /*agricole */
    animals: {
        tag: 'docteur',
        themeColor: '#087159',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    champ: {
        tag: 'docteur',
        themeColor: '#087159',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    agritools: {
        tag: 'docteur',
        themeColor: '#087159',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /* tourizm */
    hotels: {
        tag: 'docteur',
        themeColor: '#247cc7',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'Hotel', value: 'dentiste', imgSrc: 'hotel' },
                { id: 2, name: 'Maison de Hote', value: 'dentiste', imgSrc: 'maison' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
                { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
            ]
        ],
        subCateg: [
                { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
                { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
                { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    vg_agence: {
        tag: 'docteur',
        themeColor: '#ce8c64',
        directoryTable: '01_docteur',
        systemActive: true,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مكتب سياحة', value: 'dentiste', imgSrc: 'bureaux' },
                { id: 2, name: 'وكالة أسفار', value: 'dentiste', imgSrc: 'agence' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مكتب سياحة', value: 'dentiste', imgSrc: 'bureaux' },
                { id: 2, name: 'وكالة أسفار', value: 'dentiste', imgSrc: 'agence' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'مكتب سياحة', value: 'dentiste', imgSrc: 'bureaux' },
            { id: 2, name: 'وكالة أسفار', value: 'dentiste', imgSrc: 'agence' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },

    /* generale */
    admin_a_mu: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'ولاية', value: 'dentiste', imgSrc: 'baladia' },
                { id: 2, name: 'بلدية', value: 'dentiste', imgSrc: 'baladia' },
            ],
            [
                { id: 3, name: 'معتمدية', value: 'dentiste', imgSrc: 'baladia' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'معتمدية', value: 'dentiste', imgSrc: 'baladia' },
                { id: 2, name: 'بلدية', value: 'dentiste', imgSrc: 'baladia' },
                { id: 3, name: 'ولاية', value: 'dentiste', imgSrc: 'baladia' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'معتمدية', value: 'dentiste', imgSrc: 'baladia' },
            { id: 2, name: 'بلدية', value: 'dentiste', imgSrc: 'baladia' },
            { id: 3, name: 'ولاية', value: 'dentiste', imgSrc: 'baladia' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_a_police: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'مركز تجنيد', value: 'dentiste', imgSrc: 'police' },
                { id: 2, name: 'أمن', value: 'dentiste', imgSrc: 'police' },
                { id: 3, name: 'حرس', value: 'dentiste', imgSrc: 'police' },
                { id: 4, name: 'شرطة', value: 'dentiste', imgSrc: 'police' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'مركز تجنيد', value: 'dentiste', imgSrc: 'police' },
                { id: 2, name: 'أمن', value: 'dentiste', imgSrc: 'police' },
                { id: 3, name: 'حرس', value: 'dentiste', imgSrc: 'police' },
                { id: 4, name: 'شرطة', value: 'dentiste', imgSrc: 'police' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'مركز تجنيد', value: 'dentiste', imgSrc: 'police' },
            { id: 2, name: 'أمن', value: 'dentiste', imgSrc: 'police' },
            { id: 3, name: 'حرس', value: 'dentiste', imgSrc: 'police' },
            { id: 4, name: 'شرطة', value: 'dentiste', imgSrc: 'police' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},

        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_a_ar: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'إدارة جهوية', value: 'dentiste', imgSrc: 'admin' },
                { id: 2, name: 'مندوبية جهوية', value: 'dentiste', imgSrc: 'admin' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'إدارة جهوية', value: 'dentiste', imgSrc: 'admin' },
                { id: 2, name: 'مندوبية جهوية', value: 'dentiste', imgSrc: 'admin' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'إدارة جهوية', value: 'dentiste', imgSrc: 'admin' },
            { id: 2, name: 'مندوبية جهوية', value: 'dentiste', imgSrc: 'admin' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},
        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_a_court: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'محكمة تعقيب', value: 'dentiste', imgSrc: 'Cour' },
                { id: 2, name: 'محكمة إستئناف', value: 'dentiste', imgSrc: 'Cour' },
            ],
            [
                { id: 3, name: 'محكمة إبتدائية ', value: 'dentiste', imgSrc: 'Cour' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'محكمة تعقيب', value: 'dentiste', imgSrc: 'Cour' },
                { id: 2, name: 'محكمة إستئناف', value: 'dentiste', imgSrc: 'Cour' },
                { id: 3, name: 'محكمة إبتدائية ', value: 'dentiste', imgSrc: 'Cour' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'محكمة تعقيب', value: 'dentiste', imgSrc: 'Cour' },
            { id: 2, name: 'محكمة إستئناف', value: 'dentiste', imgSrc: 'Cour' },
            { id: 3, name: 'محكمة إبتدائية ', value: 'dentiste', imgSrc: 'Cour' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},
        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    admin_a_mosq: {
        tag: 'docteur',
        themeColor: '#0275c5',
        directoryTable: '01_docteur',
        systemActive: false,
        systemName: 'نظام إدارة العيادات',
        systemLink: 'https://system.abyedh.tn/Landing/docteur',
        iconName: '',
        WiconName: '',
        adsImage: '',
        xxxxxxxxxx: '',
        yyyyyyyyyy: '',
        adsText: [
            ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
            '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
        ],
        subCatagSmall: [
            [
                { id: 1, name: 'جامع', value: 'dentiste', imgSrc: 'Mosquee' },
                { id: 2, name: 'مسجد', value: 'dentiste', imgSrc: 'Mosquee' },
            ]   
        ],
        subCatagLarge:[
            [
                { id: 1, name: 'جامع', value: 'dentiste', imgSrc: 'Mosquee' },
                { id: 2, name: 'مسجد', value: 'dentiste', imgSrc: 'Mosquee' },
            ]
        ],
        subCateg: [
            { id: 1, name: 'جامع', value: 'dentiste', imgSrc: 'Mosquee' },
            { id: 2, name: 'مسجد', value: 'dentiste', imgSrc: 'Mosquee' },
        ],
        profileImg:'',
        cardProfile:[
                {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
                {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
                {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
                {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
                {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
                {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
                {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},
        ],
        profileBtns:[
                {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
                {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},

        ],
        profileTarif:true,

    },
    // ambassade: {
    //     tag: 'docteur',
    //     themeColor: '#0275c5',
    //     directoryTable: '01_docteur',
    //     system trueActive:,
    //      systemName: 'نظام إدارة العيادات',
    //     systemLink: 'https://system.abyedh.tn/Landing/docteur',
    //     iconName: '',
    //     WiconName: '',
    //     adsImage: '',
    //     xxxxxxxxxx: '',
    //     yyyyyyyyyy: '',
    //     adsText: [
    //         ['<h5>بوابة <span style="color:#dc3545 !important;"> طبيب</span> عبارة عن محرك بحث تفاعلي . تنجم تلوج علي أي طبيب حسب الإختصاص اللي تحتاجو و تنجم تاخو معاه موعد و تعرف المعلومات اللي تحتاجها الكل و تنضم مواعيدك مع طبيبك ...</h5>',
    //         '<h5>في المقابل كانك طبيب البوابة هاذي توفرلك <span style="color:#dc3545 !important;"> نظام محاسبة و إدارة </span> للعيادة متاعك و تخليك ديما متصل بيها من خلال برنامج إدارة سحابي يربط العيادة بالطبيب بالعاملين فيها بالمريض و بأي جهة أخري حسب الطلب .</h5>']
    //     ],
    //     subCatagSmall: [
    //         [
    //             { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
    //             { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
    //         ]   
    //     ],
    //     subCatagLarge:[
    //         [
    //             { id: 1, name: 'مطبعة', value: 'dentiste', imgSrc: 'printer' },
    //             { id: 2, name: 'بحوث', value: 'dentiste', imgSrc: 'printer' },
    //         ]
    //     ],
    //     subCateg: [
    //             { id: 1, name: 'أسنان', value: 'dentiste', imgSrc: 'STOMATOLOGIE' },
    //             { id: 2, name: 'أطفال', value: 'dentiste', imgSrc: 'PEDIATRIE' },
    //             { id: 3, name: 'المجاري البولية', value: 'dentiste', imgSrc: 'UROLOGIE' },
    //     ],
    //     profileImg:'',
    //     cardProfile:[
    //             {id:1, name:'الاسم و اللقب ', resultTag:'Name' , icon:'person-circle'},
    //             {id:2, name:' الاختصاص ', resultTag:'Genre' , icon:'arrows-move'},
    //             {id:3, name:' الهاتف ', resultTag:'Tel' , icon:'telephone-forward-fill'},
    //             {id:4, name:' الولاية ', resultTag:'Gouv' , icon:'geo-alt-fill'},
    //             {id:5, name:' المنطقة ', resultTag:'Deleg' , icon:'geo-alt'},
    //             {id:6, name:' العنوان ', resultTag:'Adress' , icon:'pin-map-fill'},
    //             {id:7, name:' الخبرة ', resultTag:'' , icon:'star-half'},
    //     ],
    //     profileBtns:[
    //         {id:1, name:' حجز موعد   ' , icon:'calendar' , link:'Action/docteur', bgColor:''},
    //         {id:2, name:'متابعة  ' , icon:'eye' , link:'Suivie/docteur', bgColor:''},
    //     ],
    //     profileTarif:true,
    // },
}
export default AbyedhADIL 